<template>
    <!-- <q-layout view="hHh lpR fFf"> -->
    <!-- <customHeader title="비밀번호 입력" path="mypage" /> -->
    <q-page-container>
        <q-page>
            <div class="full-screen">
                <div class="text-center pw__content">
                    <div class="pw__inner">
                        <p class="mypageMenuTt10">비밀번호를 입력해주세요.</p>
                        <img src="@/assets/images/icon/img_mypage_security.png" />
                        <q-form style="margin: 0 auto" @submit="onSubmit">
                            <q-input
                                outlined
                                clearable
                                clear-icon="close"
                                type="password"
                                v-model="wPassword"
                                bg-color="white"
                                placeholder="비밀번호"
                                lazy-rules
                                :rules="[(val) => (val && val.length > 0) || '비밀번호를 입력해 주세요.']"
                                @keyup.enter="onSubmit"
                            >
                            </q-input>
                            <CusButton :type="200" :label="`확인`" @onReturn="onSubmit" />
                        </q-form>
                    </div>
                </div>
            </div>
        </q-page>
    </q-page-container>
    <!-- </q-layout> -->
</template>

<script setup>
import { onMounted, ref, watch, defineEmits } from 'vue';
import customHeader from '@/components/layouts/header/header.vue';
import { checkPw } from '@/api/modules/mypage.js';
import CqBtn from '@/components/quasar/cqBtn.vue';
import CusButton from '@/components/widget/CusButton.vue';
import { useQuasar } from 'quasar';
import { useRouter, useRoute } from 'vue-router';
import { GlobalStore } from '@/store';
import { DialogStore } from '@/store/modules/dialog';
const dStore = DialogStore();
const gStore = GlobalStore();
const router = useRouter();
const route = useRoute();
const $q = useQuasar();
const wPassword = ref();
const isDisableSubmitBtn = ref(true);

const props = defineProps({
    isValid: {
        type: Boolean,
        default: false,
        required: true,
    },
});
const emit = defineEmits(['update:isValid']);
const onReturn = () => {
    // console.log(' --onReturn : start');
    emit('update:isValid', true);
};

watch(wPassword, (a, b) => {
    isDisableSubmitBtn.value = !wPassword.value;
});

onMounted(() => {
    // console.log('--pw-token-', gStore.token);
});
////////////////////////////----OnClick----////////////////////////////
const onSubmit = async () => {
    isDisableSubmitBtn.value = true;
    // console.log('--String(wPassword.value)--', String(wPassword.value));
    const res = await checkPw(gStore.token, String(wPassword.value));
    isDisableSubmitBtn.value = false;
    // console.log('--res( . )--', res.data.data.chkResult);

    if (res && res.status === 200)
        if (res.data.data.chkResult) onReturn();
        // if (res.data.data.chkResult) router.push('/userinfo');
        else dStore.openMsg(`비밀번호가 일치하지 않습니다. 다시 입력해 주세요.`);
};
// const onBack = () => {
//     router.push('/mypage');
// };
// const onHome = () => {
//     router.push('/learninghome');
// };
</script>

<style scoped lang="scss">
.roundedBtnOutPrimary {
    width: 100%;
    padding: 2.5vmin 3.33vmin;
    border-radius: 1vmin;
    /* border: 1px solid black;  */
    background-color: #8e43f0;
}

//////// qqquasarDeep
::v-deep {
    input {
        padding: 1.6vw;
        font-size: 1.2vw;
        color: $color_gray_900;
        line-height: 1.6vw;

        ::placeholder {
            color: $color_gray_600;
        }
    }

    .q {
        &-field {
            margin-top: 0px;

            &__bottom {
                font-size: 1.1vw;
                font-weight: 500;
                line-height: 1.4vw;

                &--animated {
                    padding-top: 5px;
                }
            }

            &__control {
                border-radius: 1vmin;
                height: 100%;
            }

            &__label {
                top: 50%;
                left: 1.6vw;
                font-size: 1.2vw;
                color: $color_gray_600;
                line-height: 1.6vw;
                transform: translateY(-50%);
            }

            &--with-bottom {
                // padding-bottom: 3vmin;
                padding-bottom: 1.8vw;
            }

            &--float {
                .q-field__label {
                    top: 0.8vw;
                    font-size: 0.8vw;
                    @include transform(translateY(-40%));
                }
            }
        }

        &-item__label {
            font-size: 24px;
        }
    }
}
.full-screen {
    position: relative;
    height: calc(100vh - 7.17vmin);
}

.pw {
    &__content {
        position: absolute;
        top: 43%;
        left: 0;
        width: 100%;
        @include transform(translateY(-50%));
    }

    &__inner {
        width: 30%;
        max-width: 600px;
        margin: 0 auto;
    }
}
</style>
